import { BadgeSize, IconBadge } from "@/components/icon-badge/icon-badge";
import { useTranslation } from "react-i18next";
import { RelocationOrderStatusConfig } from "./_helpers/get-status-config";

export enum RelocationOrderStatusContainerVariant {
  DEFAULT = "DEFAULT",
  COMPACT = "COMPACT",
}

type RelocationOrderStatusContainerProps = {
  config: RelocationOrderStatusConfig;
  variant?: RelocationOrderStatusContainerVariant;
};

export function RelocationOrderStatusContainer({
  config,
  variant = RelocationOrderStatusContainerVariant.DEFAULT,
}: RelocationOrderStatusContainerProps) {
  const { t } = useTranslation(["fit", "common"]);
  const label = config.labelParams ? t(config.label, config.labelParams) : t(config.label);
  const tooltip = config.tooltipParams ? t(config.tooltip, config.tooltipParams) : t(config.tooltip);
  const isCompact = variant === RelocationOrderStatusContainerVariant.COMPACT;

  return (
    <div className="flex items-center gap-2">
      <IconBadge
        icon={config.icon}
        color={{
          background: config.iconClasses.background,
          foreground: config.iconClasses.foreground,
          tooltipVariant: config.tooltipVariant,
        }}
        tooltip={tooltip}
        size={isCompact ? BadgeSize.Sm : BadgeSize.Md}
      />
      <span className={isCompact ? "text-sm" : undefined}>{label}</span>
    </div>
  );
}
